function getNestedProp(obj, path = '', separator = '.') {
  if (!obj) return undefined;

  const props = path.split(separator);
  return props.reduce((prev, curr) => prev && prev[curr], obj);
}

export default getNestedProp;
